<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  isPlayer: {
    type: Boolean,
    default: false,
  },
});

const actors = props.data.actors?.length > 0 ? props.data.actors : [props.data.actor];

const routeResolver = {
  LiveTVVideo: {
    detail: {
      name: 'program-details',
      params: {
        id: props.data._id,
      },
    },
  },
  Video: {
    detail: {
      name: 'video-details',
      params: {
        id: props.data.urlId,
      },
    },
  },
};
</script>

<template>
  <div>
    <template v-if="actors">
      <NuxtLink class="shrink-0" :to="`/${actors?.[0]?.urlId}`">
        <AtomImageNuxtImage
          :src="actors?.[0]?.avatar"
          draggable="false"
          :bucket-alias="actors[0].avatar.includes('avatars') ? 'avatars' : ''"
          resize="150x150"
          class="size-11 select-none rounded-full object-cover lg:size-16"
          alt="Actor"
        />
      </NuxtLink>
      <div class="py-1 md:pr-7">
        <div v-for="actor in actors" :key="actor?.id" class="inline-flex">
          <NuxtLink
            :to="`/${actor?.urlId}`"
            class="mr-1 line-clamp-1 text-sm font-semibold lg:text-xl"
            >{{ actor.name }}{{ actors.length > 1 ? ',' : '' }}</NuxtLink
          >
        </div>
        <p v-if="!isPlayer" class="line-clamp-1 text-xs lg:text-base">
          {{ data.title }}
        </p>
        <NuxtLink
          v-else
          :to="routeResolver[data.contentType]?.detail"
          class="line-clamp-1 text-xs lg:text-base"
        >
          {{ data.title }}
        </NuxtLink>
      </div>
    </template>
    <template v-else>
      <NuxtLink class="shrink-0" :to="`/${data.actor?.urlId}`">
        <AtomImageNuxtImage
          :src="data.actor?.avatar"
          draggable="false"
          resize="150x150"
          class="size-11 select-none rounded-full object-cover lg:size-16"
          alt="Actor"
        />
      </NuxtLink>
      <div class="py-1 md:pr-7">
        <NuxtLink
          :to="`/${data.actor?.id}`"
          class="mr-1 line-clamp-1 text-sm font-semibold lg:text-xl"
          >{{ data.actor.name }}</NuxtLink
        >

        <p class="line-clamp-1 text-xs lg:text-base">
          {{ data.title }}
        </p>
      </div>
    </template>
    <slot />
  </div>
</template>
